import styled from "styled-components";

const ErrorText = styled.div`
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.error};
  margin-top: 0.5rem;
  font-size: 14px;
`;

export default ErrorText;
